import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=4df2bcd4&scoped=true"
import script from "./preview.vue?vue&type=script&lang=ts"
export * from "./preview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df2bcd4",
  null
  
)

export default component.exports